import React, { FC } from 'react';
import './style.scss';

export const Unauthenticated: FC = () => (
  <div className="unauthenticated-component">
    <h1>Du er ikke logget inn</h1>
  </div>
);
